import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

interface Props extends SvgIconProps {}

const DeleteCrossIcon = ({ ...props }: Props) => {
  return (
    <SvgIcon
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.6568 0.457528L7.99998 6.11438L2.34313 0.457528C2.09308 0.207479 1.75394 0.0670034 1.40032 0.0670034C1.0467 0.0670035 0.70756 0.207479 0.457511 0.457528C0.207463 0.707576 0.0669874 1.04671 0.0669874 1.40034C0.0669873 1.75396 0.207463 2.0931 0.457512 2.34315L6.11437 8L0.457512 13.6569C0.207463 13.9069 0.0669873 14.246 0.0669874 14.5997C0.0669874 14.9533 0.207463 15.2924 0.457511 15.5425C0.70756 15.7925 1.0467 15.933 1.40032 15.933C1.75394 15.933 2.09308 15.7925 2.34313 15.5425L7.99998 9.88562L13.6568 15.5425C13.9069 15.7925 14.246 15.933 14.5996 15.933C14.9533 15.933 15.2924 15.7925 15.5425 15.5425C15.7925 15.2924 15.933 14.9533 15.933 14.5997C15.933 14.246 15.7925 13.9069 15.5425 13.6569L9.8856 8L15.5425 2.34315C15.7925 2.0931 15.933 1.75396 15.933 1.40034C15.933 1.04671 15.7925 0.707576 15.5425 0.457528C15.2924 0.207479 14.9533 0.0670023 14.5996 0.067003C14.246 0.0670023 13.9069 0.207479 13.6568 0.457528Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default DeleteCrossIcon;
